import moment from 'moment';

const diffDatesInMilliseconds = (date1: Date, date2: Date): number => (
  date2.getTime() - date1.getTime()
);

const formatDateFilename = (date?: string): string => (
  moment(date).format('MM-DD-YYYY_HH-mm-ss')
);

const formatDateFromNow = (date?: string): string => {
  const secondsElapsed = moment().diff(date, 'seconds');
  if (secondsElapsed >= 60 || secondsElapsed < 0) {
    return moment(date).fromNow();
  }
  return `${secondsElapsed} second${secondsElapsed <= 1 ? '' : 's'} ago`;
};

const datePrettyDisplay = (date?: string): string => (
  moment(date).format('MMMM Do YYYY, H:mm:ss')
);

export {
  diffDatesInMilliseconds,
  formatDateFilename,
  formatDateFromNow,
  datePrettyDisplay,
};
